'use strict';

import Scrollbar from 'smooth-scrollbar';

export function smoothScrollbarInit(
  options = {},
  selector = '#page-smooth-scroll'
) {
  let root = document.getElementsByTagName('html')[0];
  root.classList.add('page-smooth-scroll');

  const scrollbar = Scrollbar.init(document.querySelector(selector), {
    ...options,
  });

  return scrollbar;
}
